// RowComponent.tsx
import React from 'react';
const styles = require('./styles.pcss');

interface RowComponentProps {
  rowData: Record<string, any>;
  isSelected: boolean;
  onSelect: (id: number) => void;
  onRowClick?: (rowData: Record<string, any>) => void;
  visibleRowData: string[];
  isDisabled?: boolean;
  allowSelect?: boolean;
}

const BulkEditRowComponent: React.FC<RowComponentProps> = ({
  rowData,
  isSelected = false,
  onSelect,
  onRowClick,
  visibleRowData,
  isDisabled = false,
  allowSelect = true,
}) => {
  const handleClick = () => {
    if (!isDisabled) {
      if (onRowClick) {
        onRowClick(rowData);
      } else {
        onSelect(rowData.id);
      }
    }
  };

  return (
    <tr
      className={`${styles.tableRow} ${isDisabled ? styles.disabledRow : ''}`}
      onClick={handleClick}
    >
      {allowSelect && (
        <td>
          <input
            type="checkbox"
            checked={isSelected}
            readOnly
            disabled={isDisabled}
          />
        </td>
      )}
      {visibleRowData.map((key, index) => (
        <td key={index}>
          {typeof rowData[key] === 'object' && rowData[key] !== null
            ? JSON.stringify(rowData[key])
            : rowData[key]}
        </td>
      ))}
    </tr>
  );
};

export default BulkEditRowComponent;
